import { render } from "./MobileFooter.vue?vue&type=template&id=2b8843cd&scoped=true&ts=true"
import script from "./MobileFooter.vue?vue&type=script&lang=ts"
export * from "./MobileFooter.vue?vue&type=script&lang=ts"

import "./MobileFooter.vue?vue&type=style&index=0&id=2b8843cd&scoped=true&lang=css"
import "./MobileFooter.vue?vue&type=style&index=1&id=2b8843cd&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b8843cd"]])

export default __exports__